import ApiClient from '@/api-client';

export default class StaticModel {
    static instance() {
        return new this();
    }

    static for(...args) {
        const self = this.instance();

        return self.for(...args);
    }

    static generateNumericId(prefix = '') {
        let result = '';
        const length = 10;
        const characters = '0123456789';
        const charactersLength = characters.length;

        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }

        if (prefix) {
            result = `${prefix}-${result}`;
        }

        return result;
    }

    /**
     * Retrieves the instance of the class and filters the records based on the provided field and value.
     *
     * @param {string} field - The field to filter records on.
     * @param {*} value - The value to filter records by.
     * @returns Model - The model.
     */
    static where(field, value) {
        const self = this.instance();

        return self.where(field, value);
    }

    static isActive() {
        const self = this.instance();

        return self.isActive();
    }

    /** return Model */
    static whereIn(field, values) {
        const self = this.instance();

        return self.whereIn(field, values);
    }

    /** return Model */
    static limit(limit) {
        const self = this.instance();

        return self.limit(limit);
    }

    static list() {
        const self = this.instance();

        return self.list();
    }

    /** return Model */
    static with(...include) {
        const self = this.instance();

        return self.with(...include);
    }

    static when(condition, callback) {
        const self = this.instance();

        return self.when(condition, callback);
    }

    static hasMany(model) {
        const self = this.instance();

        return self.hasMany(model);
    }

    static async find(id) {
        const self = this.instance();

        return self.find(id);
    }

    static get() {
        const self = this.instance();

        return self.get();
    }

    static first() {
        const self = this.instance();

        return self.first();
    }

    static create(data) {
        const self = this.instance();

        return self.create(data);
    }

    static api() {
        return ApiClient;
    }

    static sort() {
        const self = this.instance();

        return self.sort();
    }

    /**
     * Retrieves the API URL for the model.
     *
     * @param {boolean} withParams - Whether to include the parameters in the URL.
     * @returns {string} - The API URL.
     */
    static getApiUrl(withParams = false) {
        const self = this.instance();

        return self.getApiUrl(withParams);
    }

    static generateId(prefix = '') {
        return this.generateNumericId(prefix);
    }

    static orderBy(field, direction = 'asc') {
        const self = this.instance();

        return self.orderBy(field, direction);
    }

    static applyInstanceCollection(data, model, meta) {
        const self = this.instance();

        return self.applyInstanceCollection(data, model, meta);
    }

    static async getRecentlyViewed() {
        const response = await this.api().get('/api/recently-viewed', { params: { model: this.className } });

        return response.data;
    }

    static async removeRecentlyViewed(id) {
        await this.api().delete('/api/recently-viewed', {
            data: {
                model: this.className,
                id,
            },
        });
    }

    static async setRecentlyViewed(id) {
        const self = this.instance();

        return self.setRecentlyViewed(id);
    }
}
